export default __webpack_public_path__ + "static/media/Group510@2x.ffa37802.png";